"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exec = exports.skip = exports.takeWhile = exports.take = exports.isTransformerResult = exports.filter = exports.map = exports.concat = exports.aggregatesCombinator = exports.expandAggregates = exports.groupCombinator = void 0;
var utils_1 = require("./utils");
var accessor_1 = require("./accessor");
var valueToString = function (value) {
    value = (0, utils_1.isPresent)(value) && value.getTime ? value.getTime() : value;
    return value + "";
};
/**
 * @hidden
 */
var groupCombinator = function (field) {
    var prop = (0, accessor_1.getter)(field, true);
    var position = 0;
    return function (agg, value) {
        agg[field] = agg[field] || {};
        var groupValue = prop(value);
        var key = valueToString(groupValue);
        var values = agg[field][key] || { __position: position++, aggregates: {}, items: [], value: groupValue };
        values.items.push(value);
        agg[field][key] = values;
        return agg;
    };
};
exports.groupCombinator = groupCombinator;
/**
 * @hidden
 */
var expandAggregates = function (result) {
    if (result === void 0) { result = {}; }
    Object.keys(result).forEach(function (field) {
        var aggregates = result[field];
        Object.keys(aggregates).forEach(function (aggregate) {
            aggregates[aggregate] = aggregates[aggregate].result();
        });
    });
    return result;
};
exports.expandAggregates = expandAggregates;
var aggregatesFuncs = function (name) { return ({
    average: function () {
        var value = 0;
        var count = 0;
        return {
            calc: function (curr) {
                if ((0, utils_1.isNumeric)(curr)) {
                    value += curr;
                    count++;
                }
                else {
                    value = curr;
                }
            },
            result: function () { return (0, utils_1.isNumeric)(value) ? value / count : value; }
        };
    },
    count: function () {
        var state = 0;
        return {
            calc: function () { return state++; },
            result: function () { return state; }
        };
    },
    max: function () {
        var state = Number.NEGATIVE_INFINITY;
        return {
            calc: function (value) {
                state = (0, utils_1.isNumeric)(state) || (0, utils_1.isDate)(state) ? state : value;
                if (state < value && ((0, utils_1.isNumeric)(value) || (0, utils_1.isDate)(value))) {
                    state = value;
                }
            },
            result: function () { return state; }
        };
    },
    min: function () {
        var state = Number.POSITIVE_INFINITY;
        return {
            calc: function (value) {
                state = (0, utils_1.isNumeric)(state) || (0, utils_1.isDate)(state) ? state : value;
                if (state > value && ((0, utils_1.isNumeric)(value) || (0, utils_1.isDate)(value))) {
                    state = value;
                }
            },
            result: function () { return state; }
        };
    },
    sum: function () {
        var state = 0;
        return {
            calc: function (value) {
                value = (0, utils_1.isPresent)(value) ? value : 0;
                state += value;
            },
            result: function () { return state; }
        };
    }
}[name]()); };
/**
 * @hidden
 */
var aggregatesCombinator = function (descriptors) {
    var functions = descriptors.map(function (descriptor) {
        var fieldAccessor = (0, accessor_1.getter)(descriptor.field, true);
        var aggregateName = (descriptor.aggregate || "").toLowerCase();
        var aggregateAccessor = (0, accessor_1.getter)(aggregateName, true);
        return function (state, value) {
            var fieldAggregates = state[descriptor.field] || {};
            var aggregateFunction = aggregateAccessor(fieldAggregates)
                || aggregatesFuncs(aggregateName);
            aggregateFunction.calc(fieldAccessor(value));
            fieldAggregates[descriptor.aggregate] = aggregateFunction;
            state[descriptor.field] = fieldAggregates;
            return state;
        };
    });
    return function (state, value) { return functions.reduce(function (agg, calc) { return calc(agg, value); }, state); };
};
exports.aggregatesCombinator = aggregatesCombinator;
/**
 * @hidden
 * Adds the value to the `arr` and produces a new array.
 *
 * > The original array will be modified.
 */
var concat = function (arr, value) {
    arr.push(value);
    return arr;
};
exports.concat = concat;
/**
 * @hidden
 * Returns a reducer that will apply the specified transformation to the value.
 */
var map = function (transform) { return (function (reduce) { return (function (acc, curr, index) { return reduce(acc, transform(curr, index)); }); }); };
exports.map = map;
/**
 * @hidden
 * Returns a reducer that will filter out items which do not match the `Predicate`.
 */
var filter = function (predicate) { return (function (reduce) { return (function (acc, curr) { return predicate(curr) ? reduce(acc, curr) : acc; }); }); };
exports.filter = filter;
/**
 * @hidden
 */
var isTransformerResult = function (source) {
    return (0, utils_1.isPresent)(source.__value);
};
exports.isTransformerResult = isTransformerResult;
var reduced = function (x) {
    if ((0, exports.isTransformerResult)(x)) {
        return x;
    }
    return {
        __value: x,
        reduced: true
    };
};
/**
 * @hidden
 * Returns a reducer that will take the specified number of items.
 */
var take = function (count) { return (function (reduce) { return (function (acc, curr) { return count-- > 0 ? reduce(acc, curr) : reduced(acc); }); }); };
exports.take = take;
/**
 * @hidden
 * Returns a reducer that will take the specified number of items.
 */
var takeWhile = function (predicate) { return (function (reduce) { return (function (acc, curr) { return predicate(curr) ? reduce(acc, curr) : reduced(acc); }); }); };
exports.takeWhile = takeWhile;
/**
 * @hidden
 * Returns a reducer that will skip the specified number of items.
 */
var skip = function (count) { return (function (reduce) { return (function (acc, curr) { return count-- <= 0 ? reduce(acc, curr) : acc; }); }); };
exports.skip = skip;
/**
 * @hidden
 * Transforms the data by applying the supplied transformer.
 */
var exec = function (transform, initialValue, data) {
    var result = initialValue;
    for (var idx = 0, length_1 = data.length; idx < length_1; idx++) {
        result = transform(result, data[idx], idx);
        if ((0, exports.isTransformerResult)(result)) {
            result = result.__value;
            break;
        }
    }
    return result;
};
exports.exec = exec;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-data-query@1.7.1/~/@progress/kendo-data-query/dist/npm/transducers.js
// module id = 157
// module chunks = 0